import { withStyles } from "@material-ui/core/styles"
import CircularProgress from "@material-ui/core/CircularProgress"

export const GFWSpinner = withStyles(theme => ({
  root: {
    // fill:"#E72569",
    color: "#E72569",
  },
}))(CircularProgress)
